var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtUniversity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 62,
    viewBox: "0 0 135 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.31 9.282h26.923v52.716H40.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.112 0h22.439v61.998H56.112zM83.877 18.921h21.352v43.077H83.877zM13.153 25.354H37.46v36.644H13.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.906 11.748h17.75v50.25h-17.75zM8.505 20.97h13.089V62H8.505zM108.096 29.278h16.625v32.72h-16.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.905 38.191H135v23.807h-12.095zM0 38.191h12.095v23.807H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M26.824 37.98h81.351v23.986h-81.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9C4B9",
    d: "M26.123 59.163h82.752v2.794H26.123z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M108.132 33.623H26.868L25.42 38.07h84.156zM83.176 40.6h3.787v6.657h-3.787z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M86.96 47.26h-3.782l-.221 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(82.957 40.6)"
  }), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M88.443 40.6h3.787v6.657h-3.787z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M92.227 47.26h-3.782l-.218 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 6.655H.216V5.07L4.003 1.4z",
    transform: "translate(88.227 40.6)"
  })), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M95.415 40.6h3.787v6.657h-3.787z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M99.197 47.26h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(95.196 40.6)"
  }), /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M100.682 40.6h3.787v6.657h-3.787z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M104.464 47.26h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(100.463 40.6)"
  }))), /*#__PURE__*/React.createElement("g", null, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M83.176 50.016h3.787v6.658h-3.787z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M86.96 56.678h-3.782l-.221 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(82.957 50.016)"
  }), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M88.443 50.016h3.787v6.658h-3.787z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M92.227 56.678h-3.782l-.218 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 6.655H.216V5.07L4.003 1.4z",
    transform: "translate(88.227 50.016)"
  })), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M95.415 50.016h3.787v6.658h-3.787z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M99.197 56.678h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(95.196 50.016)"
  }), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M100.682 50.016h3.787v6.658h-3.787z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M104.464 56.678h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(100.463 50.016)"
  })))), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M30.53 40.6h3.788v6.657H30.53z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M34.316 47.26h-3.782l-.22 1.65h4.223z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(30.315 40.6)"
  }), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M35.798 40.6h3.787v6.657h-3.787z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M39.583 47.26h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(35.582 40.6)"
  })), /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M42.77 40.6h3.788v6.657H42.77z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M46.555 47.26H42.77l-.218 1.65h4.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(42.552 40.6)"
  }), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M48.038 40.6h3.787v6.657h-3.787z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M51.822 47.26h-3.784l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(47.819 40.6)"
  }))), /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M30.53 50.016h3.788v6.658H30.53z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M34.316 56.678h-3.782l-.22 1.65h4.223z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(30.315 50.016)"
  }), /*#__PURE__*/React.createElement("g", null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M35.798 50.016h3.787v6.658h-3.787z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M39.583 56.678h-3.782l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.216V5.07L4.006 1.4z",
    transform: "translate(35.582 50.016)"
  })), /*#__PURE__*/React.createElement("g", null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M42.77 50.016h3.788v6.658H42.77z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M46.555 56.678H42.77l-.218 1.65h4.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(42.552 50.016)"
  }), /*#__PURE__*/React.createElement("g", null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M48.038 50.016h3.787v6.658h-3.787z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M51.822 56.678h-3.784l-.219 1.65h4.222z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.005 6.655H.22V5.07L4.005 1.4z",
    transform: "translate(47.819 50.016)"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C5",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.403 4.455h81.351v1.65H1.403z",
    transform: "translate(25.421 33.623)"
  }), /*#__PURE__*/React.createElement("g", null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "m52.166 30.73 15.333-12.547 15.333 12.548z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M80.123 61.986H54.877v-31.26L67.5 20.346l12.624 10.38z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M58.383 48.008h18.233v13.98H58.383z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M6.217 29.965v13.838h.841V30.46h16.55v13.343h.843V29.965z",
    transform: "translate(52.166 18.183)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M54.175 46.033h26.649v2.115h-26.65z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.568 54.196c-.098-1.989-2.328-3.577-5.07-3.577-2.74 0-4.97 1.59-5.068 3.577l-.005 7.781h10.147l-.004-7.78z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.076 11.358h5.071l-.004-7.78C10.045 1.59 7.815 0 5.076 0v11.358z",
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(62.425 50.619)"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.306 28.013a2.813 2.813 0 0 1-2.805 2.82 2.813 2.813 0 0 1-2.805-2.82 2.813 2.813 0 0 1 2.805-2.822 2.813 2.813 0 0 1 2.805 2.822z",
    fill: "#BD8F7E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.711 28.013a2.216 2.216 0 0 1-2.21 2.223 2.216 2.216 0 0 1-2.21-2.223c0-1.229.989-2.223 2.21-2.223s2.21.994 2.21 2.223z",
    fill: "#F9DFD1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M57.702 33.838h3.787v9.197h-3.787z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M61.486 43.04h-3.782l-.218 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 9.195H.216V7.609l3.787-3.67z",
    transform: "translate(57.486 33.838)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M62.97 33.838h3.786v9.197H62.97z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M66.754 43.04h-3.782l-.219 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 9.195H.216V7.609l3.787-3.67z",
    transform: "translate(62.753 33.838)"
  }), /*#__PURE__*/React.createElement("g", null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M68.236 33.838h3.787v9.197h-3.787z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M72.021 43.04H68.24l-.219 1.65h4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.003 9.195H.216V7.609l3.787-3.67z",
    transform: "translate(68.02 33.838)"
  })), /*#__PURE__*/React.createElement("g", null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M73.504 33.839h3.787v9.197h-3.787z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M77.289 43.04h-3.782l-.219 1.65h4.22z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M73.511 35.019h3.784l.22-1.65h-4.222zM68.244 35.019h3.784l.219-1.65h-4.222zM62.976 35.019h3.785l.218-1.65h-4.221zM57.709 35.019h3.784l.219-1.65H57.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M19.8 9.665h-3.786V8.079l3.787-3.67z",
    transform: "translate(57.49 33.369)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.713 13.361 15.333 2.98l12.62 10.384.004-.831L15.333 2.15 2.71 12.532z",
    transform: "translate(52.166 18.183)"
  }), /*#__PURE__*/React.createElement("g", null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M76.288 58.076h4.209v3.91h-4.209zM76.302 48.164h4.208v3.263h-4.208z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h4.208v3.263H0z",
    transform: "translate(76.302 48.164)"
  }), /*#__PURE__*/React.createElement("g", null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M54.49 58.076h4.208v3.91H54.49zM54.504 48.164h4.208v3.263h-4.209z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h4.208v3.263H0z",
    transform: "translate(54.504 48.164)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M47.87 14.757h1.64V62h-1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.465 19.455c-2.857 1.957-5.716-1.957-8.573 0v-4.893c2.857-1.957 5.716 1.957 8.573 0v4.893z",
    fill: "#F6C760"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.926 56.438-.41-.186c-.242.539-.94 1.776-1.737 2.226-.22.087-.287-.165-.3-.353V56.03h-.81v2.108c-.015.197-.092.45-.34.317-.78-.47-1.459-1.671-1.696-2.203l-.41.186c.041.092.882 1.95 2.064 2.507.264.135.353.539.383.82V62h.809v-2.216c.027-.287.116-.704.39-.837h-.01c1.183-.554 2.023-2.413 2.064-2.507l.003-.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.354 53.213a2.302 2.302 0 0 0-2.276-2.624h-.039a2.296 2.296 0 0 0-1.966-1.114c-.834 0-1.563.447-1.966 1.114h-.039a2.302 2.302 0 0 0-2.276 2.624 2.315 2.315 0 0 0-.654 1.614 2.302 2.302 0 0 0 2.297 2.31c.679 0 1.29-.296 1.71-.768a2.273 2.273 0 0 0 1.855 0c.422.472 1.03.768 1.711.768a2.302 2.302 0 0 0 2.297-2.31c0-.628-.248-1.197-.654-1.614z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.711 56.685c-.678 0-1.29-.298-1.71-.767a2.273 2.273 0 0 1-1.855 0 2.283 2.283 0 0 1-1.711.767A2.3 2.3 0 0 1 10.15 54.6a2.302 2.302 0 0 0 2.285 2.537c.679 0 1.29-.296 1.71-.768a2.273 2.273 0 0 0 1.855 0c.422.472 1.03.768 1.711.768a2.302 2.302 0 0 0 2.286-2.537 2.301 2.301 0 0 1-2.286 2.085z",
    fill: "#528C10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.275 54.027-.543-.245c-.319.715-1.244 2.353-2.298 2.95-.294.114-.38-.22-.4-.468v-2.778h-1.07v2.794c-.023.261-.125.596-.453.417-1.035-.621-1.932-2.216-2.244-2.918l-.543.246c.055.121 1.17 2.585 2.737 3.32.35.181.467.713.505 1.087v3.561h1.071v-3.538c.037-.379.153-.933.517-1.11h-.011c1.567-.735 2.681-3.199 2.736-3.32l-.004.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.168 49.755a3.052 3.052 0 0 0-3.014-3.477h-.053a3.034 3.034 0 0 0-5.208 0h-.052a3.052 3.052 0 0 0-3.014 3.477 3.062 3.062 0 0 0-.866 2.138 3.052 3.052 0 0 0 3.044 3.062c.9 0 1.708-.394 2.266-1.018a3.01 3.01 0 0 0 2.456 0 3.028 3.028 0 0 0 2.267 1.018 3.052 3.052 0 0 0 3.044-3.062c0-.832-.33-1.586-.866-2.138h-.004z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.99 54.357c-.9 0-1.709-.394-2.267-1.018a3.01 3.01 0 0 1-2.456 0A3.028 3.028 0 0 1 108 54.357a3.049 3.049 0 0 1-3.028-2.764c-.009.099-.013.2-.013.3a3.052 3.052 0 0 0 3.043 3.062c.9 0 1.709-.394 2.267-1.018a3.01 3.01 0 0 0 2.456 0 3.028 3.028 0 0 0 2.267 1.018 3.052 3.052 0 0 0 3.03-3.362 3.052 3.052 0 0 1-3.028 2.764h-.004z",
    fill: "#528C10"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.146 53.156-.606-.273c-.356.798-1.385 2.624-2.563 3.289-.328.128-.426-.245-.445-.52v-3.094H22.34v3.114c-.025.291-.14.663-.506.466-1.153-.692-2.153-2.469-2.502-3.252l-.606.272c.062.138 1.301 2.883 3.049 3.702.391.201.521.795.565 1.212V62h1.193v-3.903c.041-.422.171-1.038.577-1.237h-.012c1.748-.82 2.99-3.566 3.049-3.704z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.255 48.394c.021-.152.032-.305.032-.463 0-1.884-1.52-3.413-3.392-3.413h-.057a3.383 3.383 0 0 0-5.805 0h-.057c-1.873 0-3.392 1.529-3.392 3.413 0 .156.011.311.032.463a3.41 3.41 0 0 0-.966 2.383c0 1.884 1.52 3.413 3.392 3.413a3.378 3.378 0 0 0 2.527-1.135 3.372 3.372 0 0 0 2.738 0 3.375 3.375 0 0 0 2.527 1.135c1.872 0 3.392-1.529 3.392-3.413 0-.928-.369-1.767-.966-2.383h-.005z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.83 53.52a3.378 3.378 0 0 1-2.528-1.134 3.372 3.372 0 0 1-2.738 0 3.375 3.375 0 0 1-2.527 1.134 3.402 3.402 0 0 1-3.376-3.08c-.011.11-.016.223-.016.335 0 1.884 1.52 3.412 3.392 3.412a3.378 3.378 0 0 0 2.527-1.134 3.372 3.372 0 0 0 2.738 0 3.375 3.375 0 0 0 2.527 1.134c1.873 0 3.392-1.528 3.392-3.412 0-.112-.004-.225-.015-.335a3.402 3.402 0 0 1-3.377 3.08z",
    fill: "#528C10"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtUniversity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-university.a6e8a9d15a531dc441e1231fb666e6ad.svg";